/*!

=========================================================
* Black Dashboard React v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/black-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/black-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import HtmlContent from "components/Custom/htmlContent";
import content from 'content.json'; // Importing the JSON file


// reactstrap components
import { Card, CardHeader, CardBody, CardTitle, Row, Col } from "reactstrap";

function TermsOfService() {
  return (
    <>
      <div className="content">
        <Row>
          <Col md="10">
            <Card>
              
              <CardBody>
                <div className="typography-line">
              
<h1>
Terms of Service
</h1>
<p>
Last updated: 2025-09-01
</p>
<br/>

<p>
Welcome to {content.brandname}. By using this application, you agree to the following terms:
</p>
<br/>

<h2>
Service Description
</h2>
<p>
{content.brandname} connects to your public Spotify playlist to provide enhanced music insights and features.
</p>
<br/>

<h2>
Eligibility
</h2>
<p>
You must sign in using google to use this service.
</p>
<br/>

<h2>
Use of the Service
</h2>
<p>
• You may not use this app for unlawful or abusive purposes. You may not resell the data. And you respect the terms of service of Amsterdam Events with regards to the event program.
</p>
<br/>

<h2>
Disclaimer of Warranty
</h2>
<p>
This service is provided "as is," without warranties of any kind.
</p>
<br/>

<h2>
Limitation of Liability
</h2>
<p>
We are not liable for any damages arising from use of this service.
</p>
<br/>

<h2>
Termination
</h2>
<p>
You may stop using the service at any time. We may suspend or terminate access if you violate these terms.
</p>
<br/>

<h2>
Changes to Terms
</h2>
<p>
We may update these Terms. Continued use after changes constitutes acceptance.
</p>
<br/>

<h2>
Contact
</h2>
<p>
If you have questions about these Terms, contact us at:
</p>
<p>
📧 steve.depeijper@gmail.com
</p>
<br/>

                </div>
          
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default TermsOfService;
